'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Alert = require('react-bootstrap/lib/Alert');

var _Alert2 = _interopRequireDefault(_Alert);

var _CaseUpdateFormBody = require('../page-case/main-details/CaseUpdates/CaseUpdateFormBody');

var _CaseUpdateFormBody2 = _interopRequireDefault(_CaseUpdateFormBody);

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _commonFormsy = require('../common-formsy');

var _UpdateRequestButton = require('./UpdateRequestButton');

var _UpdateRequestButton2 = _interopRequireDefault(_UpdateRequestButton);

var _UpdateRequestEmailModule = require('./UpdateRequestEmailModule');

var _UpdateRequestEmailModule2 = _interopRequireDefault(_UpdateRequestEmailModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var UpdateRequestForm = (_dec = (0, _mobxReact.inject)('OptionsStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(UpdateRequestForm, _Component);

  function UpdateRequestForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UpdateRequestForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpdateRequestForm.__proto__ || Object.getPrototypeOf(UpdateRequestForm)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'caseUpdateData', _descriptor, _this), _initDefineProp(_this, 'showRequiredStatusError', _descriptor2, _this), _initDefineProp(_this, 'isSubmitting', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UpdateRequestForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.OptionsStore.prepareOptionStore();
    }
  }, {
    key: 'onCaseUpdateChange',
    value: function onCaseUpdateChange(data) {
      if (data.tracking_status) {
        this.showRequiredStatusError = false;
      }
      this.caseUpdateData = data;
    }
  }, {
    key: 'appendResponse',
    value: function appendResponse(body, formData) {
      var email = formData.response_email;

      if (!email) {
        return body;
      }

      return body.concat('\n\nEmail: ' + email);
    }
  }, {
    key: 'onValidSubmit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
        var onSubmit, body, unserializedData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.caseUpdateData.tracking_status) {
                  _context.next = 3;
                  break;
                }

                this.showRequiredStatusError = true;
                return _context.abrupt('return');

              case 3:
                onSubmit = this.props.onSubmit, body = this.appendResponse(this.caseUpdateData.body, formData), unserializedData = _extends({}, this.caseUpdateData, formData, { body: body, unappendedBody: this.caseUpdateData.body });


                this.isSubmitting.setTrue();
                _context.next = 7;
                return onSubmit(unserializedData);

              case 7:
                this.isSubmitting.setFalse();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onValidSubmit(_x) {
        return _ref2.apply(this, arguments);
      }

      return onValidSubmit;
    }()
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      if (!this.caseUpdateData.tracking_status) {
        this.showRequiredStatusError = true;
      }
    }
  }, {
    key: 'handleAlertDismiss',
    value: function handleAlertDismiss() {
      this.showRequiredStatusError = false;
    }
  }, {
    key: 'setRefForm',
    value: function setRefForm(comp) {
      this.refForm = comp;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          fromTask = _props.fromTask,
          followUpText = _props.followUpText;


      return _react2.default.createElement(
        _commonFormsy.Form,
        { className: 'modal-form-style', ref: this.setRefForm, onValidSubmit: this.onValidSubmit, onInvalidSubmit: this.onInvalidSubmit },
        _react2.default.createElement(_CaseUpdateFormBody2.default, {
          followUpText: followUpText,
          fromUpdateRequest: true,
          onChange: this.onCaseUpdateChange
        }),
        this.showRequiredStatusError && _react2.default.createElement(
          _Alert2.default,
          { bsStyle: 'danger', onDismiss: this.handleAlertDismiss },
          _react2.default.createElement(
            'p',
            null,
            'Tracking Status is required'
          )
        ),
        _react2.default.createElement(_UpdateRequestEmailModule2.default, null),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(_UpdateRequestButton2.default, { disabled: (0, _get3.default)(this.refForm, 'submitErrors') || this.isSubmitting.isTrue, fromTask: fromTask })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return UpdateRequestForm;
}(_react.Component), _class3.propTypes = {
  followUpText: _propTypes2.default.string.isRequired,
  fromTask: _propTypes2.default.bool,
  onSubmit: _propTypes2.default.func,
  OptionsStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'caseUpdateData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'showRequiredStatusError', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'isSubmitting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'onCaseUpdateChange', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onCaseUpdateChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onValidSubmit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onValidSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onInvalidSubmit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onInvalidSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleAlertDismiss', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleAlertDismiss'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = UpdateRequestForm;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(UpdateRequestForm, 'UpdateRequestForm', '/app/src/components/page-tasks/UpdateRequestForm.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-tasks/UpdateRequestForm.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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